import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DigitZeroPipe } from '../../../features/questionnaires/features/table-grid/pipes/digit-zero.pipe';
import { ContactTooltipComponent } from 'src/app/shared/components/contact-tooltip/contact-tooltip.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { GlobalStore } from 'src/app/store/global-store';
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';
import { environment } from 'src/environment';
import { GlobalService } from '../../services/global-service';
import { LoginService } from '../../services/login-service';
import { AuthStore } from 'src/app/store/auth-store';
import { STORAGE_KEYS } from '../../storage-keys';

@Component({
    selector: 'que-logged-user',
    imports: [CommonModule, DigitZeroPipe, ContactTooltipComponent, OverlayModule, TranslateDirective, TranslatePipe],
    templateUrl: './logged-user.component.html',
    styleUrls: ['./logged-user.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoggedUserComponent {
  @Input()
  isPreview = false;
  isUserDetailsOpen = false;
  #globalStore = inject(GlobalStore);
  #loginService = inject(LoginService);
  #authService = inject(MsalService);
  #authStore = inject(AuthStore);
  userDetails$ = toSignal(this.#globalStore.loggedUserDetails$);
  isRoleAdmin$ = toSignal(this.#globalStore.isRoleAdmin$);

  readonly positonArea = [{
    originX: 'end',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'top',
  }] as ConnectedPosition[];

  logOut() {
    if (environment.auth == "azure") {
      localStorage.removeItem(STORAGE_KEYS.authHeader);
      this.#loginService.logOut().subscribe(x => {
        if (environment.auth == "azure") {
          this.#authService.instance.logout();
        }
      })
    } else {
      this.#authStore.logOut();
    }

  }

  goToBoardirector() {
    window.location.href = this.isRoleAdmin$() ? environment.boardirectorUrl : environment.directorsViewUrl;
  }
}

